import { addNode } from "../utils/localDb";
import { NodeSummary } from "../utils/query";
import { sleep } from "../utils/utils";

interface ConnectionRecord {
    firstName: string;
    lastName: string;
    url: string;
    emailAddress: string | null;
    company: string | null;
    position: string | null;
    connectedOn: string;
}


function convertConnectionRecordToNodeSummary(record: ConnectionRecord): NodeSummary {
    return {
        id: crypto.randomUUID(),
        circleId: '1',
        type: 'person',
        name: record.firstName + ' ' + record.lastName,
        subtitle: record.company ?? '',
        description: '',
        tags: [],
        avatars: [],
        timestamp: record.connectedOn,
        lastUpdated: record.connectedOn
    };
}

const createNode = async (record: ConnectionRecord) => {
    const nodeSummary = convertConnectionRecordToNodeSummary(record);
    console.log("NodeSummary:", nodeSummary);
    await addNode(nodeSummary);
}

async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (file) {
        const reader = new FileReader();
        const fileContent = await new Promise<string | ArrayBuffer | null>((resolve, reject) => {
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            reader.readAsText(file);
        });

        if (typeof fileContent === 'string') {
            console.log(fileContent);
            await parseConnectionData(fileContent);
        }



    }
}

async function parseConnectionData(csvText: string): Promise<void> {
    // Split the input text into rows
    const rows = csvText.trim().split("\n");

    // Find the actual header line
    const headerIndex = rows.findIndex(row =>
        row.startsWith("First Name,Last Name,URL,Email Address,Company,Position,Connected On")
    );

    if (headerIndex === -1) {
        throw new Error("Header not found in the CSV.");
    }

    // Extract only the rows starting from the header
    const validRows = rows.slice(headerIndex);

    // Check if the number of records exceeds 1,000 (excluding the header)
    if (validRows.length - 1 > 1000) {
        throw new Error("Record length exceeds 1,000.");
    }

    // Parse the header row to ensure correct column indices
    const headers = validRows[0].split(",");
    const expectedHeaders = ["First Name", "Last Name", "URL", "Email Address", "Company", "Position", "Connected On"];
    if (!expectedHeaders.every((header, idx) => headers[idx] === header)) {
        throw new Error("Unexpected CSV format.");
    }

    // Process each row after the header
    for (let i = 1; i < validRows.length; i++) {
        const row = validRows[i];
        const columns = row.split(",");

        const record: ConnectionRecord = {
            firstName: columns[0]?.trim() || "",
            lastName: columns[1]?.trim() || "",
            url: columns[2]?.trim() || "",
            emailAddress: columns[3]?.trim() || null,
            company: columns[4]?.trim() || null,
            position: columns[5]?.trim() || null,
            connectedOn: columns[6]?.trim() || "",
        };

        // Call the createNode function with the parsed record
        await createNode(record);
    }

    await sleep(100);
    //queryClient.invalidateQueries({ queryKey: ['nodes'] });
}

const LinkedInCsvImporter = () => {
    return (
        <dialog id="linkedin_csv_importer_dialog" className="modal">
            <form method="dialog" className="modal-box">
                <h2>LinkedIn CSV Importer</h2>
                <input
                    type="file"
                    accept=".csv"
                    onChange={handleFileChange}
                />
                <div className="modal-action">
                    <button className="btn">Close</button>
                </div>
            </form>
        </dialog>
    );
}

export default LinkedInCsvImporter;